<div class="cnt-column" style="height: 100%">
  <scrolldiv
    style="flex: 1; width: 100%"
    [scrollerSize]="20"
    [navigatorSize]="14"
    [scrollVerticalIndent]="0"
    cls="lightScroll"
  >
    <div class="startTrialWindow g1Background">
      <div class="cnt-column-centered box">
        <div [height]="20"></div>
        <div class="cnt-row-centered" style="width: 90%">
          <div class="h2Font g4Color filler"></div>

          <div class="h1Font b1Color centered" i18n>
            <b>{{ 'TRY_ENTERPRISE' | translate }}</b>
          </div>

          <div class="h2Font g4Color filler"></div>

          <simple-btn
            [width]="30"
            [height]="30"
            [cornerRadius]="20"
            [horizontalPadding]="0"
            [leftSpace]="0"
            [rightSpace]="0"
            [borderWidth]="2"
            [rightImgCls]="'btn-close'"
            [rightImgHoverCls]="'btn-close-hover'"
            [text]="''"
            [hoverFillCls]="'g4Background'"
            [textColorCls]="'g4Color'"
            [borderColorCls]="'g4Border'"
            [hoverBorderColorCls]="'g4Border'"
            [backgroundFillCls]="'g2Background'"
            (click)="onCloseTrial()"
            data-testid="sharePlanPopupCloseButton"
          >
          </simple-btn>
        </div>

        <div [height]="5"></div>
        <div class="p1Font b1Color centered" i18n>{{ 'FREE_FOR_7_DAYS' | translate }}</div>
        <div [height]="5"></div>

        <div class="forecastImg"></div>
        <div [height]="5"></div>

        <div class="startTrialWindowBox">
          <div class="startTrialWindowText">
            <div class="p1Font b1Color left-align left-padding" i18n>
              {{ 'ENJOY_THE_BENEFITS_OF' | translate }} <span class="h3Font">{{ 'FREE' | translate }}</span> {{ 'FOR_7_DAYS' | translate }}
            </div>
          </div>

          <div class="startTrialWindowText">
            <div class="p1Font b1Color left-align left-padding" i18n>
              {{ 'BUILD' | translate }} <b>{{ 'YOUR' | translate }}</b> {{ 'BUSINESS_KNOWLEDGE_INTO_A' | translate }} <b>{{ 'YOUR' | translate }}</b> {{ 'BUSINESS' | translate }}.
            </div>
          </div>

          <div class="startTrialWindowText">
            <div class="p1Font b1Color left-align left-padding">
              •	<span class="tab" i18n>{{ 'CREATE_UP_TO_10' | translate }}</span><br>
              •	<span class="tab" i18n>{{ 'SEE_THE_FINANCIAL_OUTCOMES' | translate }}</span><br>
              •	<span class="tab" i18n>{{ 'EXPLORE_DIFFERENT_SCENARIOS' | translate }}</span><br>
              •	<span class="tab" i18n>{{ 'ANALYSE_YOUR_ACTUALS_VS' | translate }}</span><br>
              •	<span class="tab" i18n>{{ 'CONNECT_YOUR_XERO_OR' | translate }}</span><br>
              •	<span class="tab" i18n>{{ 'SHARE_PLANS_IN_REAL' | translate }}</span><br>
              •	<span class="tab" i18n>{{ 'UPGRADE_YOUR_SUBSCRIPTION_AT' | translate }}**</span><br>
            </div>
          </div>

          <div class="startTrialWindowText" style="padding-bottom: 0px">
            <div class="p3Font b1Color left-align left-padding" i18n>
              * {{ 'REPORT_AND_CHART_DOWNLOADING' | translate }} <a target="_blank" href="https://businesshelp.brixxsupport.com/support/solutions/articles/13000050602-what-are-downloads-like-examples-included">({{ 'EXAMPLES' | translate }})</a>
            </div>
          </div>

          <div class="startTrialWindowText" style="padding-top: 0px">
            <div class="p3Font b1Color left-align left-padding" i18n>
              ** {{ 'ACCOUNT_WILL_REVERT_TO' | translate }}
            </div>
          </div>
        </div>

        <div [height]="20"></div>

        <simple-btn
          [hoverTextColor]="'white'"
          [backgroundFillCls]="'o2Background'"
          [hoverFillCls]="'o1Background'"
          [boxShadowCls]="'primary-shadow'"
          [text]="startTrialText | translate"
          [textCls]="'large-btn-text'"
          style="margin: auto"
          [height]="40"
          [width]="170"
          [cornerRadius]="30"
          [horizontalPadding]="20"
          (click)="startTrial()"
        >
        </simple-btn>

        <div [height]="20"></div>
      </div>
    </div>
  </scrolldiv>
</div>